function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M80.4789 235.446C80.7859 236.185 81.4186 236.739 82.1914 236.946L183.767 264.163C185.832 264.716 187.633 262.659 186.813 260.685L135.242 136.603C134.935 135.864 134.303 135.31 133.53 135.103L31.9546 107.886C29.8895 107.332 28.0877 109.389 28.9082 111.364L80.4789 235.446Z",
  fill: "url(#paint0_radial_front)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M242.032 411.58C242.287 410.723 242.97 410.06 243.834 409.828L317.111 390.194C319.058 389.672 320.823 391.487 320.247 393.419L294.487 479.788C294.231 480.646 293.549 481.309 292.684 481.541L219.408 501.175C217.461 501.697 215.695 499.882 216.272 497.95L242.032 411.58Z",
  fill: "url(#paint1_radial_front)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M956.117 69.678C956.455 69.06 957.031 68.6072 957.711 68.4249L1013.08 53.5902C1015.26 53.0035 1017.09 55.326 1016 57.315L979.98 123.217C979.643 123.835 979.067 124.288 978.386 124.47L923.022 139.305C920.833 139.892 919.007 137.569 920.094 135.58L956.117 69.678Z",
  fill: "url(#paint2_radial_front)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M846.627 452.099C844.448 451.465 844.092 448.528 846.058 447.393L894.175 419.612C894.784 419.261 895.509 419.173 896.183 419.369L972.747 441.616C974.926 442.249 975.282 445.187 973.316 446.322L925.198 474.102C924.59 474.453 923.865 474.541 923.191 474.345L846.627 452.099Z",
  fill: "url(#paint3_radial_front)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M460.839 17.3126C462.976 16.5485 464.986 18.7207 464.058 20.7922L448.698 55.0913C448.411 55.7322 447.875 56.2281 447.213 56.4645L395.593 74.9201C393.456 75.6842 391.447 73.5119 392.374 71.4405L407.735 37.1414C408.022 36.5005 408.558 36.0046 409.219 35.7682L460.839 17.3126Z",
  fill: "url(#paint4_radial_front)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M1112.34 244.441C1112.83 243.889 1113.53 243.572 1114.27 243.572H1204.44C1206.66 243.572 1207.84 246.194 1206.37 247.857L1125.04 339.762C1124.55 340.314 1123.85 340.631 1123.11 340.631H1032.93C1030.71 340.631 1029.53 338.009 1031 336.346L1112.34 244.441Z",
  fill: "url(#paint5_radial_front)"
});

var _ref8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_front",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(-2 214.387) rotate(-30) scale(157.911 162.06)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ECFFDA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#AFFFFA"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_front",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(193.753 423.247) rotate(30) scale(115.842 118.885)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ECFFDA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#AFFFFA"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint2_radial_front",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(900.528 78.6183) rotate(30) scale(91.1331 93.5272)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ECFFDA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#AFFFFA"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint3_radial_front",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(840.826 450.413) rotate(15) scale(88.6734 91.0029)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ECFFDA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#AFFFFA"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint4_radial_front",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(466.527 15.2789) rotate(159.125) scale(63.246 64.9075)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ECFFDA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#AFFFFA"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint5_radial_front",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(1085.62 260.751) rotate(45) scale(137.262 140.867)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ECFFDA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#AFFFFA"
})));

var SvgFrontParallelograms = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1208,
    height: 503,
    viewBox: "0 0 1208 503",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFrontParallelograms, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/front-parallelograms.ac3b9218.svg";
export { ForwardRef as ReactComponent };